// Organisation list used by the board create form (Create Dashboard/Report page + old modal).
// TODO: replace with the organisation API once available.
export const ORG_LIST = [
  {
    OrganisationID: "5eb537c660c090232c0d807b",
    Name: "Best Foods Whole Sale1",
  },
  {
    OrganisationID: "5ec3c4c72ca923bd5e8a6640",
    Name: "South Harrow Food and Wine",
  },
  {
    OrganisationID: "5ec5f702dcd86fe64a959475",
    Name: "Ecologital12",
  },
  {
    OrganisationID: "5ec5f81bdcd86fe64a95947e",
    Name: "Ecologital123",
  },
  {
    OrganisationID: "5ec5f96cdcd86fe64a959486",
    Name: "Ecologital1122",
  },
  {
    OrganisationID: "5ed9b1661be0ae9b446d5bcd",
    Name: "Best Foods New",
  },
  {
    OrganisationID: "5ed9c0181be0ae9b446d5bd4",
    Name: "Ecologital",
  },
  {
    OrganisationID: "5ed9d1ac1be0ae9b446d5be1",
    Name: "Ecologital12258",
  },
  {
    OrganisationID: "5ed9d4661be0ae9b446d5be9",
    Name: "Ecologital223",
  },
  {
    OrganisationID: "5ed9d5911be0ae9b446d5bf1",
    Name: "Ecologital12345",
  },
  {
    OrganisationID: "5ed9d5db1be0ae9b446d5bf9",
    Name: "Ecologital333",
  },
  {
    OrganisationID: "5ed9e6831be0ae9b446d5c01",
    Name: "KRISHNA CASH AND CARRY",
  },
  {
    OrganisationID: "5f005e18abbc59fbdd589a33",
    Name: "Select Super Market - West Croydon",
  },
  {
    OrganisationID: "5f006023abbc59fbdd589a3b",
    Name: "Mini Super Store",
  },
  {
    OrganisationID: "5f0061a0abbc59fbdd589a43",
    Name: "T and O Store",
  },
  {
    OrganisationID: "5f006250abbc59fbdd589a4b",
    Name: "Clark Store",
  },
  {
    OrganisationID: "5f0435c247913a61cc420a28",
    Name: "Ecologital Dev",
  },
  {
    OrganisationID: "5f05e7f454a5908787dccee8",
    Name: "Ecologital Dev Payment",
  },
  {
    OrganisationID: "5f05e81156c85fb55f80f759",
    Name: "Ecologital Dev Payment2",
  },
  {
    OrganisationID: "5f19647bc70bf4bf64c0f37b",
    Name: "Shankar-Retail",
  },
  {
    OrganisationID: "5f19683fc70bf4bf64c0f383",
    Name: "Bestfoods Whole Sale",
  },
  {
    OrganisationID: "5f4f334754a5908787dccf09",
    Name: "Test",
  },
  {
    OrganisationID: "5f58962fdf41239122095743",
    Name: "Suren Pvt Ltd",
  },
  {
    OrganisationID: "5f59e004df4123912209574b",
    Name: "Testq",
  },
  {
    OrganisationID: "5f59e3d9df41239122095753",
    Name: "Ecologital_npos",
  },
  {
    OrganisationID: "5f59f61adf4123912209575b",
    Name: "Ssueen",
  },
  {
    OrganisationID: "5f8985ffdf41239122095763",
    Name: "Casipillai",
  },
  {
    OrganisationID: "5f9113f9df4123912209576b",
    Name: "Ecologital NPOS",
  },
];
